import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';

import './Tooltip.scss';

export const Tooltip = ({
  children,
  content,
  position = 'bottom',
  delay = 0,
  className = '',
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const wrapperRef = useRef(null);

  const handleMouseEnter = () => {
    setIsVisible(true);
  };

  const handleMouseLeave = () => {
    setIsVisible(false);
  };

  return (
    <div 
      className={`tooltip-wrapper ${className}`}
      ref={wrapperRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}
      {isVisible && content && (
        <div className={`custom-tooltip custom-tooltip-${position}`}>
          {content}
        </div>
      )}
    </div>
  );
};


Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  content: PropTypes.node.isRequired,
  position: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
  delay: PropTypes.number,
  className: PropTypes.string,
};
